import { FormValidations } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const confirmMobileDialogValidations = (): FormValidations => {
  return {
    verificationCode: {
      required: true,
      message: "confirmMobileDialogValidations.verificationCode",
      regex: /^[a-z0-9]{6}$/,
      type: "Pattern"
    } as PatternValidatonRule
  };
}